<div
  class="photo"
  (mouseenter)="hover = true"
  (mouseleave)="hover = false"
  [ngClass]="{ circular: isCircular }"
>
  <div class="overlay" *ngIf="hover" (click)="changePhoto()"></div>
  <p *ngIf="!hover && !photo">{{ title }}</p>

  <ca-circular-loader *ngIf="photo" [progress]="progress">
    <ng-template>
      <ca-image-loader
        tappable
        [background]="false"
        [image]="photo | filedownloadurl | async"
        [fit]="fit"
      ></ca-image-loader>
    </ng-template>
  </ca-circular-loader>
  <input
    (change)="processWebImage($event)"
    #fileInput
    type="file"
    accept="image/*"
    style="display: none"
  />
</div>
